import { TrendModel } from '../../../shared/data/models/trend.model';

export interface TrendingHashState {
  trending: TrendModel[];
  loading: boolean;
  error: string;
}

export const initialTrendingHashState: TrendingHashState = {
  trending: [],
  loading: false,
  error: ''
};
